
import Vue from "vue";
import SammanstallningField from "./SammanstallningField.vue";
import { mapFields } from "vuex-map-fields";

export default Vue.extend({
    name: "AnmalareSammanstallning",
    components: {
        SammanstallningField,
    },
    computed: {
        ...mapFields([
            "kontaktuppgifter.anmalareVarJobbar",
            "kontaktuppgifter.anmalareDittFornamn",
            "kontaktuppgifter.anmalareDittEfternamn",
            "kontaktuppgifter.anmalareDinTelefon",
            "kontaktuppgifter.anmalareOvrigKontaktuppgift",
            "kontaktuppgifter.anmalareKontaktuppgift",
            "kontaktuppgifter.anmalareRelationTill",
        ]),
    },
});
